<template>
  <div class="shopm-continner">
    <div class="header-title">租号中心</div>
    <div class="sub-continner">
      <div class="person-card-content-second"></div>
      <div class="main-card">
        <div class="main-card-content">
          提示：请勾选要租的账号后点击批量租号即可。
          <div>然后再到养号中选择账号进行养号操作！</div>
        </div>
      </div>
      <div class="main-list">
        <van-checkbox-group v-model="checkboxGroup" ref="checkboxGroup">
          <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh"> -->
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <van-cell
                v-for="item in dataList"
                :key="item.id"
                :title="item.title"
                :label="item.label"
                @click="buyRentNumber(item)"
              >
                <template #title>
                  <span style="font-size: x-small">
                    租号：<span>{{ item.rentNumbers }}</span>
                  </span>
                </template>
                <template #default>
                  <div
                    style="
                      display: flex;
                      flex-direction: row;
                      justify-content: flex-end;
                      align-items: center;
                    "
                  >
                    <!-- <div style="font-size: xx-small; color: #44b1eb;margin-right: 10px;">
                      {{ item.createTime }}
                    </div> -->
                    <van-checkbox
                      :name="item"
                      @click.stop.native="() => {}"
                    ></van-checkbox>
                  </div>
                </template>
                <template #label>
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      white-space: nowrap;
                      overflow: hidden;
                    "
                  >
                    <span style="flex-shrink: 0;">价格：</span
                    ><span
                      style="
                        color: red;
                        min-width: 0;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      "
                      >{{ item.rentNumberPrice.toFixed(2) }}</span
                    ><span style="flex-shrink: 0; padding-left: 15px"
                      >状态：</span
                    ><span
                      style="
                        color: red;
                        font-size: x-small;
                        min-width: 0;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      "
                      >{{ item.rentStatus }}</span
                    >
                  </div>
                </template>
              </van-cell>
            </van-list>
          <!-- </van-pull-refresh> -->
        </van-checkbox-group>
      </div>
      <div class="operation-bottom-area">
        <div class="operation-item-one"><van-button @click="batchOperation">批量租号</van-button></div>
        <!-- <div class="operation-item-two">
          <van-checkbox v-model="checked" @change="chooseAndProcess"
            >全选</van-checkbox
          >
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import {
  queryRentnumbers,
  buyRentNumbers,
  batchBuyRentNumbers,
} from "../../api/system/sys_plateform";
import { Dialog, Toast } from "vant";
export default {
  name: "shopm",
  data() {
    return {
      value: "",
      columns: ["杭州", "宁波", "温州", "嘉兴", "湖州"],
      showPicker: false,
      showCalendar: false,
      timeValue: "",
      refreshing: false,
      loading: false,
      finished: false,
      dataList: [],
      queryForm: {
        rentNumber: null,
        rentStatus: 0,
      },
      checkboxGroup: [],
      checked: false,
      pagination: {
        pageNum: 0,
        pageSize: 20,
        total: null,
      },
    };
  },
  mounted() {
    this.$emit("titleChange", "商店");
  },
  methods: {
    batchOperation() {
      batchBuyRentNumbers(this.checkboxGroup.map((item) => item.id)).then((res) => {
        if (res.success) {
           Dialog.alert({
                  title: "提示",
                  message: "批量租号成功！",
                }).then(() => {
                  // on close
                });
          // 购买成功后清空勾选并重新从第一页加载列表，
          // 避免：1)勾选残留导致同一号码被重复购买 2)列表停在旧分页 3)列表被强制截断只显示一页
          this.reloadList();
        }
      }).catch(error=>{
        Toast.fail(error.message);
      });
    },
    chooseAndProcess() {
      if (this.checked) {
        this.$refs.checkboxGroup.toggleAll(true);
      } else {
        this.$refs.checkboxGroup.toggleAll();
      }
      //console.log(this.checkboxGroup);
    },
    buyRentNumber(rentNumber) {
      Dialog.confirm({
        title: "确认租号",
        message: rentNumber.rentNumbers,
      })
        .then(() => {
          // on confirm
          buyRentNumbers(rentNumber).then((res) => {
            if (res.success) {
              this.reloadList();
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    // 购买成功后重置列表与勾选，重新从第一页加载：
    // 1) 清空勾选，避免同一号码被再次勾选、重复购买
    // 2) 重置分页并从第一页重新拉取，避免停在旧分页
    // 3) finished 由 onLoad 按 total 判定，不再强制截断成一页
    reloadList() {
      this.checkboxGroup = [];
      this.dataList = [];
      this.pagination.pageNum = 0;
      this.finished = false;
      this.loading = false;
      this.onLoad();
    },
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    },
    onCalConfirm(date) {
      this.timeValue = `${date.getMonth() + 1}/${date.getDate()}`;
      this.showCalendar = false;
    },
    onLoad() {
      // if (this.refreshing) {
      //   this.refreshing = false;
      // }
      if (this.finished) {return;}
      else this.pagination.pageNum = this.pagination.pageNum + 1;
      this.loading = true;
      
      queryRentnumbers(this.queryForm, this.pagination)
        .then((res) => {
          if (res.success) {
            console.log(res.data);
            if (res.data.records.length > 0) {
              this.dataList.push(...res.data.records);
            }
            
            if (this.dataList.length >= res.data.total) {
              this.finished = true;
            }
          }
        })
        .catch((err) => {
          MessageBox({
            title: "提示",
            message: err.message,
            showCancelButton: true,
          });
        }).finally(() => {
          this.loading = false;
        });
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      if (!this.finished) {
        this.pagination.pageNum = this.pagination.pageNum + 1;
      }
      this.onLoad();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../root.scss";
.shopm-continner {
  background-color: rgb(249, 249, 249);
  background-image: url(../../assets/img/thembg.png);
  background-repeat: no-repeat;
  background-size: contain;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 50px;
  bottom: calc(50px + env(safe-area-inset-bottom, 0px));
  display: flex;
  flex-direction: column;
}

.sub-continner {
  flex: 1;
  min-height: 0;
  margin-top: 10;
  height: auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header-title,
.person-card-content-second,
.main-card {
  flex-shrink: 0;
}

.main-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

.van-cell span, .van-cell div{
  font-size: calculeResultFontSize(false, 2px) !important;
}
</style>
